// extracted by mini-css-extract-plugin
export default {"container":"_29gk0","disabledIcon":"_3yRI1","stakeContainer":"_2QAGX","stake":"_25zGY"};